import { useTranslation } from 'react-i18next';
import Modal from "./Modal";
import React, {useState} from "react";
import PrivacyPolicy from "../Pages/PrivacyPolicy";



function Footer({ onManageCookies, theme }) {
    const { t, i18n } = useTranslation();
    const [showModalPrivacy, setShowModalPrivacy] = useState(false);

    const onCloseModalPrivacy = (newValue) => {
        setShowModalPrivacy(newValue)
    }

    return (
        <>
            <footer className="container-footer relative z-5 mx-auto py-2 border-t flex  flex-wrap justify-content-between">
                <div onClick={() => setShowModalPrivacy(true)} className="text-center m-auto sm:ml-0 my-2 cursor-pointer">
                    { t('privacy_policy.title') }
                </div>
                <div
                    onClick={onManageCookies}
                    className="text-center m-auto sm:mr-0 my-2 cursor-pointer"
                >
                    { t('manage_cookies') }
                </div>
                <div className="text-center m-auto sm:mr-0 my-2">
                    { t('copyrightfooter') }
                </div>
            </footer>

            {showModalPrivacy && (
                <Modal themeClass={theme}>
                    <PrivacyPolicy onCheckPrivacy={onCloseModalPrivacy} footerChecked={true}/>
                </Modal>
            )}
        </>
    );
}

export default Footer;
